module.exports = __webpack_public_path__ + "static/media/upute.69d3e9c4.pdf";